import apiRequest from '../apis/api-request';
import { selectAuthToken } from '../redux/reducers/authReducers';
import { store } from '../redux/store';

const remarkService = {

    insertRemarkData: async (data) => {
        const token = selectAuthToken(store.getState())
        return apiRequest({
            method:"POST",
            url: `/api/sync/insert/individualremark`,
            data,
            headers: {
                Authorization: "Bearer " + token
            },
        });
    },

    uploadRemarkFile: async (data) => {
        const token = selectAuthToken(store.getState())
        return apiRequest({
            method:"POST",
            url: `/api/sync/insert/bulkremarkfile`,
            data,
            headers: {
                Authorization: "Bearer " + token,
                'Content-Type': 'multipart/form-data'
            },
        });
    },

};

export default remarkService;